import React, { useState } from 'react'
import Webinar from 'lemon-campaign-ui/lib/molecules/Webinar'
import linking from '../../helper/linking'
import { useHasMounted } from '../../helper/react-hooks'
import * as preferences from '../../globals/tracking/preferences'
import get from 'lodash/get'
import MediaCookieOverlay from '../cookies/mediaOverlay'

export default ({ component, defaults, handlers, campaignId }) => {
  const [accepted, setAccepted] = useState(false)
  const hasMounted = useHasMounted()

  if (!hasMounted) {
    return null
  }

  const cookies = preferences.getPreferences(campaignId)
  const mediaCookieSet = get(cookies, 'Media', false)

  const handleAccept = () => {
    setAccepted(true)
  }

  if (!mediaCookieSet) {
    return <MediaCookieOverlay onAccept={handleAccept} />
  }

  return (
    <Webinar
      {...defaults}
      hasResponsiveContainer={component.content.responsive.hasContainer}
      responsiveOptions={component.content.responsive.options}
      videoUrl={component.content.video}
      durationTrigger={component.content.duration}
      messageText={component.content.placeholderText}
      buttonText={component.content.text}
      buttonColor={component.content.backgroundColor}
      buttonTextColor={component.content.color}
      buttonLink={linking(component)}
      clickHandler={(val, extraState) => handlers.button(val, extraState, component)}
    />
  )
}
